import React, { useEffect, useState } from "react";
import { api, normalizeImageUrl } from "@/lib/api";
import { Award } from "lucide-react";

export default function Assessors() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/assessors").then(r => setItems(r.data)); }, []);
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 sm:py-24">
      <div className="mb-12 max-w-3xl">
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-700 mb-3">Asesor Kompetensi</div>
        <h1 className="font-display text-4xl sm:text-5xl font-extrabold text-emerald-950">Asesor LSP Realestat Indonesia</h1>
        <p className="mt-4 text-slate-600">Praktisi dan pakar dengan kompetensi realestat, perumahan, dan permukiman.</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6">
        {items.map(a => (
          <div key={a.id} data-testid={`assessor-${a.id}`} className="bg-white rounded-2xl overflow-hidden border border-slate-100 hover:shadow-xl transition-all group">
            <div className="aspect-[3/4] overflow-hidden bg-slate-100">
              <img src={normalizeImageUrl(a.photo_url)} alt={a.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-5">
              <div className="inline-flex items-center gap-1 text-[10px] font-bold uppercase tracking-widest text-amber-600 mb-2"><Award className="w-3 h-3" /> Asesor Kompetensi</div>
              <h3 className="font-display font-bold text-emerald-950 leading-snug">{a.name}</h3>
              <div className="text-xs text-slate-600 mt-1">{a.position}</div>
              <div className="text-xs text-slate-500 mt-2 line-clamp-2">{a.bio}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
